module.exports = __webpack_public_path__ + "img/onekeytitle.feb8cb49.png";